export default "__VITE_ASSET__Cg7hP8s5__"